import { render, staticRenderFns } from "./CommunityPage_StartNow.vue?vue&type=template&id=07e6ed56&scoped=true&"
import script from "./CommunityPage_StartNow.vue?vue&type=script&lang=js&"
export * from "./CommunityPage_StartNow.vue?vue&type=script&lang=js&"
import style0 from "./CommunityPage_StartNow.vue?vue&type=style&index=0&id=07e6ed56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e6ed56",
  null
  
)

export default component.exports